import { render, staticRenderFns } from "./CafeSupport.vue?vue&type=template&id=18b2dd2f"
import script from "./CafeSupport.vue?vue&type=script&lang=js"
export * from "./CafeSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports